"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContent = exports.DialogContainer = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _Dialog = require("../components/Dialog");
var _ErrorInfo = require("../components/ErrorInfo");
var _Loading = require("../components/Loading");
var _ProductInfoDialogDrawer = require("../components/ProductInfoDialogDrawer");
var _constants = require("../constants");
var _useTranslations = require("../hooks/useTranslations");
var _getNonDiscontinuedAndCannotBeSold = require("../utils/getNonDiscontinuedAndCannotBeSold");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const DialogContent = exports.DialogContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "ProductInfoDialog_DialogContent" */'./DialogContent')))).DialogContent
}));
const DialogContainer = ({
  analytics = {},
  dialog = {},
  initialProductCode,
  mode = _constants.DIALOG_MODE_LOADING,
  products = [],
  shared = {
    isMrpStatementEnabled: false,
    isRatingsAndReviewsEnabled: false
  },
  replaceSubscription
}) => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const isInfo = mode === _constants.NOT_FOUND || mode === _constants.DISCONTINUED;
  const content = (0, _react.useMemo)(() => {
    switch (mode) {
      case _constants.DIALOG_MODE_LOADING:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {});
      case _constants.NOT_FOUND:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorInfo.ErrorInfo, {
          title: translations.productNotFound,
          description: translations.productNotFoundDescription,
          buttonTitle: translations.goBack,
          handleButtonClick: dialog.onClose
        });
      case _constants.DISCONTINUED:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorInfo.ErrorInfo, {
          title: translations.productIsDiscontinued,
          description: translations.productIsDiscontinuedDescription,
          buttonTitle: translations.goBack,
          handleButtonClick: dialog.onClose
        });
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogContent, {
            analytics: analytics,
            initialProductCode: initialProductCode,
            mode: mode,
            products: (0, _getNonDiscontinuedAndCannotBeSold.getNonDiscontinuedAndCannotBeSold)(products),
            shared: shared,
            replaceSubscription: replaceSubscription
          })
        });
    }
  }, [mode, translations.productNotFound, translations.productNotFoundDescription, translations.goBack, translations.productIsDiscontinued, translations.productIsDiscontinuedDescription, dialog.onClose, analytics, initialProductCode, products, shared, replaceSubscription]);
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, {
      isInfo: isInfo,
      ...dialog,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
        children: content
      })
    });
  }
  const {
    open,
    onClose
  } = dialog;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfoDialogDrawer.ProductInfoDialogDrawer, {
    open: open,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
      children: content
    })
  });
};
exports.DialogContainer = DialogContainer;